/** Контакты платформы: один источник для подвала, страницы «О компании» и экрана ошибки. */
export const CONTACT_EMAIL = 'llcdata1861@gmail.com';
export const CONTACT_PHONE = '+7 (928) 132-53-36';
export const CONTACT_PHONE_HREF = `tel:${CONTACT_PHONE.replace(/[^+\d]/g, '')}`;
